import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import * as S from './style';
import { FormStatusInfo, Btn } from 'components';
import { ReactComponent as IconError } from 'assets/img/error/img_error_500.svg';

import * as PAGE_URL from 'router/PageUrl';

function InternalServer(): React.ReactElement {
    const history = useHistory();
    const onClickCallback = useCallback(
        (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            history.push('/');
        },
        [history]
    );

    return (
        <FormStatusInfo
            subTitle={['서비스에 접속할 수 없습니다.']}
            image={<IconError />}
            btnWidth={180}
            btn={
                <Btn height={44} fontStyle={'body1'} backGroundColor={'blue_900'} color={'gray_opacity_50'} href={PAGE_URL.LOGIN.path} onClick={onClickCallback}>
                    {'홈으로 돌아가기'}
                </Btn>
            }
        >
            <S.CaptionWrapper>
                기술적인 문제로 인해 일시적으로 접속되지 않습니다.
                <br />
                이용에 불편을 드려 죄송합니다.
                <br />
                잠시후 다시 시도해주세요.
                <br />
            </S.CaptionWrapper>
        </FormStatusInfo>
    );
}

export default InternalServer;
